import React, { Component } from "react";
import PricingCard from "./pricingCards";
import PricingTick from "../Icons/PricingTick.icon";
import EnergyHero from "../Icons/EnergyHero.icon";

class PricingList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="container">
        <div className="row d-flex justify-content-center align-items-stretch">
          <PricingCard
            heading="Become a super school!"
            title="Energy Hero"
            icon={<EnergyHero className="fill-primary" width="3.5rem" />}
            bar="col-12"
            text="Level-up your engagement with students, teachers and your school community."
            price="$2,495*"
            details="*Account set up and login required. Meter/s &amp; meter installation not included."
            bgColor="bg-grey-panel-dark"
            headerColor="text-ss-dark"
            features={[
              {
                title: "Energy Profile Page",
                detail:
                  'Your school\'s very own Profile Page, showing real-time (5-minute intervals) energy data and more <a href="/schools/my-school" title="My School">See example</a>.',
              },
              {
                title: "Live View",
                detail:
                  "With Live View, you can unlock school energy data in Live mode which updates every 30 seconds!",
              },
              {
                title: "Data Downloads",
                detail:
                  "Dig into the data! Registered schools can download spreadsheets straight from the energy graph.",
              },
              {
                title: "Teachers Toolkit",
                detail:
                  'Unlimited access to curriculum aligned unit & lesson plans tailored to students from year 1 through to 12. <a href="/teachers-toolkit" title="Teacher\'s Toolkit">Explore the toolkit</a>',
              },
              {
                title: "Compare Schools",
                detail:
                  "Compare and contrast your school's energy data with any (or every!) other school in the program.",
              },
              {
                title: "Display Board Ready",
                detail:
                  'Access your school\'s unique Display Board link, allowing you to display your Solar Schools data on monitors of all sizes, anywhere on campus! <a href="https://displayboard.solarschools.net/?id=1687&type=sites&key=edfb6b3f927d8e8ab64b37cdeb2d6d3de9a1bbebeed78f2dc83c232383582f8206e50f292de4df53009b54747b7ad18b0d094e1f4eabbed9377de91affaaa978" title="Display Board" target="_blank">See example</a>',
              },
              {
                title: "Planet Watch App",
                detail:
                  'The interactive app where students, teachers and the community alike can explore their school\'s energy health in the form of a planet on an iPad or computer. <a href="/planet-watch" title="Planet Watch">Learn more</a>',
              },
              {
                title: "Seamless Software Updates",
                detail:
                  "All the latest platform updates will be provided free of charge, as they are rolled out.",
              },
              {
                title: "Data API Access",
                detail:
                  "Get direct access to use our data resources, your way.",
              },
              {
                title: "Data Costs Included",
                detail:
                  "Data communications, processing and storage costs are all included in your school's subscription.",
              },
              {
                title: "Online Training",
                detail:
                  "Every school gets an online training session to help you get the most out of the program.",
              },
            ]}
          />
        </div>
      </div>
    );
  }
}

export default PricingList;



// WEBPACK FOOTER //
// ./resources/assets/js/app/Pricing/index.js